import { INVESTMENT_STYLE } from 'Config/constans';

export default function (value) {
  return INVESTMENT_STYLE[value];
}
